// extracted by mini-css-extract-plugin
export default {"editDiv":"EditableDiv_editDiv__90zpy","dotsDiv":"EditableDiv_dotsDiv__mf1pE","popUp":"EditableDiv_popUp__Jsm60"};